"use client";

import Modal from "@/components/core/Modal";
import { memo, ReactNode } from "react";
import Forms from "@/components/shared/Forms";
import { MethodTypeEnum, ModuleTypeEnum } from "@/enum";
import EditorToolModalHeader from "@/components/layouts/ToolModals/EditorToolModal/EditorToolModalHeader";
import { ITool } from "@/actions/ai-configuration/tool/types";
import { UseFormReturn } from "react-hook-form";
import { UpdateAiConfigurationData } from "@/components/shared/Forms/UpdateAiConfigurationForm/schema";

interface EditorToolProps {
  id?: string;
  name?: string;
  apiUrl?: string;
  description?: string;
  methodType?: MethodTypeEnum;
  type?: ModuleTypeEnum;
  aiConfigurationId?: string;

  index?: number | null;

  isEditing: boolean;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onSave: (toolData: ITool, index: number) => void;
  form: UseFormReturn<UpdateAiConfigurationData>;
  initialValues: UpdateAiConfigurationData;
}

const EditorToolModal = memo(
  ({
    isOpen,
    onOpenChange,
    index,
    onSave,
    form,
    isEditing,
    initialValues,
  }: EditorToolProps): ReactNode => {
    const handleCloseModal = () => {
      form.reset(initialValues);
      onOpenChange(false);
    };

    return (
      <Modal
        isOpen={isOpen}
        onOpenChange={(open) => {
          if (!open) {
            handleCloseModal();
            document.body.classList.add("modal-unlocked");
          } else {
            onOpenChange(true);
          }
        }}
        dialogTitle={isEditing ? "Editar Ferramenta" : "Nova Ferramenta"}
        dialogDescription={
          isEditing
            ? "Altere as informações da Ferramenta"
            : "Configure uma nova Ferramenta"
        }
        className="flex flex-col w-full max-w-screen-tablet items-start justify-start gap-0"
        noDefaultCloseButton
      >
        <EditorToolModalHeader
          isEditing={isEditing}
          backFn={handleCloseModal}
        />

        <div className="p-8 pt-0 flex w-full justify-center">
          <div className="p-8 pt-0 flex w-full justify-center">
            {isEditing ? (
              <Forms.UpdateToolForm
                form={form}
                index={index!}
                onSave={onSave}
                onClose={() => onOpenChange(false)}
              />
            ) : (
              <Forms.CreateToolForm
                form={form}
                index={index!}
                onSave={onSave}
                onClose={() => onOpenChange(false)}
              />
            )}
          </div>
        </div>
      </Modal>
    );
  },
);

EditorToolModal.displayName = "EditorToolModal";

export default EditorToolModal;
